import { useEffect, useState } from 'react';
import { api } from '../lib/api';
import Seo from '../components/Seo';
import { Brush } from '../components/Brush';

export default function CookiePolicy() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    api.get('/cookie-policy').then((r) => setSections(r.data));
  }, []);

  return (
    <>
      <Seo
        title="Cookie policy"
        description="Il sito VdE Tivoli 1996 non utilizza cookie né servizi di analisi di terze parti."
        path="/cookie-policy"
      />

      <header className="py-14 md:py-20">
        <div className="wrap">
          <h1 className="relative inline-block">
            <span className="display-xl">Cookie policy</span>
            <Brush className="absolute -bottom-1 left-0 h-[0.34em] w-full" opacity={0.32} />
          </h1>
        </div>
      </header>

      <section className="py-14 md:py-20">
        <div className="wrap max-w-3xl">
          {sections.map((s) => (
            <article key={s.title} className="py-8 first:pt-0">
              <h2 className="font-display text-2xl md:text-3xl">{s.title}</h2>
              {s.html && (
                <div
                  data-ui className="prosa mt-4 [&_a]:underline [&_a]:decoration-1 [&_a]:underline-offset-2 [&_code]:bg-carta-2 [&_code]:px-1 [&_li]:mt-2 [&_ul]:list-disc [&_ul]:pl-5 [&_p]:mt-3 [&_h3]:mt-6 [&_h3]:font-display [&_h3]:text-lg [&_table]:mt-4 [&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto [&_table]:text-left [&_th]:border-b [&_th]:border-inchiostro/20 [&_th]:px-3 [&_th]:py-2 [&_td]:border-b [&_td]:border-inchiostro/12 [&_td]:px-3 [&_td]:py-2 [&_td]:align-top"
                  dangerouslySetInnerHTML={{ __html: s.html }}
                />
              )}
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
